import { useEffect } from 'react';
import { FormikValues, useFormikContext } from 'formik';
import isFunction from 'lodash/isFunction';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';

interface Props<V> {
    initialValues?: V;
    values?: V;
    onValidationChange?: (isValid: boolean) => void;
    onDirtyChange?: (isValid: boolean) => void;
}

export const FormCallbacks = <V extends FormikValues = FormikValues>({
    values,
    initialValues,
    onValidationChange,
    onDirtyChange,
}: Props<V>) => {
    const { isValid, setValues, dirty } = useFormikContext();

    useEffect(() => {
        if (isFunction(onValidationChange)) {
            onValidationChange(isValid);
        }
    }, [isValid, onValidationChange]);

    useEffect(() => {
        if (!isUndefined(values) && isEmpty(initialValues)) {
            setValues(values);
        }
        // Disabled because we are interested only in a values changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values]);

    useEffect(() => {
        if (isFunction(onDirtyChange)) {
            onDirtyChange(dirty);
        }
    }, [dirty, onDirtyChange]);

    return null;
};
